export default {
  fetchDataFailed:
    "Échec du chargement des données utilisateur, veuillez réessayer ou contacter le support",
  password_changed_other_tab: "Mot de passe mis à jour dans un autre onglet",
  profile_updated_other_tab: "Profil mis à jour dans un autre onglet",
  report_updated_other_tab: "La configuration du rapport a été mise à jour dans un autre onglet.",
  logged_out_other_tab: "Vous avez été déconnecté dans un autre onglet",
  oauth: {
    processing: "Traitement de la demande de connexion...",
  },
  ticket: {
    modal_title: "Soumettre un ticket",
    not_logged_in: "Veuillez d'abord vous connecter",
    login_required:
      "La soumission d'un ticket nécessite une connexion à votre compte. Souhaitez-vous aller à la page de connexion ?",
    go_to_login: "Aller à la connexion",
    submit_success:
      "Ticket soumis avec succès ! Notre équipe d'assistance répondra dans un délai de 24 à 48 heures.",
    email: "Email",
    email_placeholder: "Veuillez saisir votre email",
    type: "Type de problème",
    type_placeholder: "Veuillez sélectionner le type de problème",
    subject: "Sujet",
    subject_placeholder: "Veuillez saisir un sujet pour votre ticket (5 à 100 caractères)",
    description: "Description du problème",
    description_placeholder: "Veuillez décrire le problème en détail",
    submit_ticket: "Soumettre le ticket",
    submit_failed: "Échec de la soumission du ticket !",
    email_send_failed_title: "Problème de notification par email",
    email_send_failed_desc:
      "Votre ticket a été soumis avec succès, mais nous avons rencontré un problème lors de l'envoi des notifications par email. Notre équipe d'assistance traitera quand même votre demande.",
  },
};
